<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container-fluid">
      <RouterLink class="navbar-brand" to="/Home" @click="handleNavClick">
        <img src="../assets/Talentinus blanco.png" alt="Logo" class="logo" />
        <img src="../assets/Talentinus white.png" alt="Logo" class="logo2" />
      </RouterLink>
      <button
        class="navbar-toggler"
        :class="{ collapsed: !isCollapsed, 'toggler-animated': true, 'toggler-open': isCollapsed }"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        :aria-expanded="isCollapsed ? 'true' : 'false'"
        aria-label="Toggle navigation"
        @click="toggleCollapse"
      >
        <font-awesome-icon v-if="!isCollapsed" icon="bars" class="fa-lg" />
        <font-awesome-icon v-else icon="times" class="fa-lg close-x" />
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <RouterLink to="/por_que" class="nav-link contentNav" @click="handleNavClick">POR QUE TALENTINUS</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/como_funciona" class="nav-link contentNav" @click="handleNavClick">COMO FUNCIONA</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/resultados" class="nav-link contentNav" @click="handleNavClick">RESULTADOS</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/precios" class="nav-link contentNav" @click="handleNavClick">PRECIOS</RouterLink>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from 'bootstrap'; // Importación correcta de Bootstrap

export default {
  name: 'NavigationBar',
  data() {
    return {
      isCollapsed: false
    }
  },
  mounted() {
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse) {
      navbarCollapse.addEventListener('show.bs.collapse', () => {
        this.isCollapsed = true;
      });
      navbarCollapse.addEventListener('hide.bs.collapse', () => {
        this.isCollapsed = false;
      });
    }
  },
  methods: {
    toggleCollapse() {
      // Bootstrap maneja el colapso
    },
    handleNavClick() {
      // Cerrar menú en móvil
      if (window.innerWidth < 768) {
        const collapseElement = document.getElementById('navbarNav');
        if (collapseElement && collapseElement.classList.contains('show')) {
          this.isCollapsed = false;
          const collapseInstance = Collapse.getInstance(collapseElement) || new Collapse(collapseElement, { toggle: false });
          collapseInstance.hide();
        }
      }
      
      // Scroll suave al inicio
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style>
.navbar {
  width: 100vw;
  min-width: 320px;
  background-color: #0F2030 !important;
  position: fixed;   /* <-- Cambiado a fixed */
  top: 0;
  left: 0;
  z-index: 1000;
}

.contentNav {
  color: #FFFFFF;
  padding-right: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  list-style: 140%;
  transform: scaleY(1.1);
  transition: color 0.2s;
}

.contentNav:hover,
.contentNav.router-link-exact-active {
  color: #C58911 !important;
}

.logo {
  height: 47.81px;
  width: auto;
}

.logo2 {
  height: 20px;
  width: auto;
}

/* Fuerza hamburguesa blanca */
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

.close-x {
  color: #fff;
  font-size: 2rem;
  line-height: 1;
  font-weight: bold;
  display: inline-block;
  width: 1.5em;
  text-align: center;
}

.navbar-toggler {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-toggler-icon,
.close-x {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 24px;
}

.toggler-animated {
  transition: transform 0.3s cubic-bezier(.4,2,.6,1);
}
.toggler-open {
  transform: rotate(180deg) scale(1.1);
}

.navbar-toggler .fa-lg {
  color: #fff;
  font-size: 2rem;
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 24px;
}

@media (max-width: 768px) {
  .navbar {
    padding: 0 8px;
  }
  .container-fluid {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    flex-wrap: nowrap !important;
  }
  .logo, .logo2 {
    height: 32px !important;
  }
  .navbar-toggler {
    margin-left: auto;
    align-self: center;
  }
  .contentNav {
    font-size: 16px !important;
    display: block;
    text-align: left;
    padding: 16px 0 !important; /* <-- Más espacio vertical */
    margin: 0 !important;
    line-height: 1.3 !important;
  }
  .navbar-nav {
    flex-direction: column !important;
    align-items: flex-start !important;
    padding: 8px 0;
    gap: 4px; /* Espacio entre cada item */
  }
  .navbar-collapse {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100vw;
    background: #0F2030;
    z-index: 1100;
    margin-top: 0;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  }
  .navbar-nav {
    padding-bottom: 12px;
  }
}
</style>
